export default "__VITE_ASSET__BMXgfHjV__"